<template>
	<button class="view-ui-button-signup button-primary" v-on:click="$emit('signup')">Join for Free</button>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/Button
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiButtonSignUp extends ViewBase {
		// Not implemented
	}
</script>
